<div class="card-body" [formGroup]="form">
  <div class="search-filter-wrapper d-flex justify-content-between flex-wrap gap-12">
    <div class="mr-2">
      <app-grid-column-search-filter
        [colDefs]="detailColDefs.length ? detailColDefs : $any(colDefs)"
        [rowData]="rowData"
        [gridApi]="gridApi"
        [groupByOptions]="groupByOptions"
        [loading]="loading"
        (selectGroupByOption)="selectGroupByOption.emit($event)"
        (clearGroupByOption)="clearGroupByOption.emit($event)"
        (applyGroupFilter)="applyGroupFilter()"
      />
    </div>

    <div class="flex-grow-1 hide-empty">
      <ng-content select=".grid-controls-middle"/>
    </div>

    @if (!hideSearch) {
      <div class="search-container d-flex gap-12 flex-shrink-1">
        <app-search-input
          class="search"
          formControlName="search"
          [placeholder]="searchInputPlaceholder"
        />

        <div class="flex-grow-1 hide-empty">
          <ng-content select=".grid-controls-refresh"/>
        </div>

        <app-list-grid-columns-filter
          [colDefs]="detailColDefs.length ? detailColDefs : $any(colDefs)"
          [gridApi]="$any(gridApi)"
          [isRowData]="!!rowData.length"
          [loading]="loading"
          (checkboxChange)="onCheckboxChange($any($event))"
          (groupCheckboxChange)="onGroupCheckboxChange($any($event))"
        />

        <div class="flex-shrink-1 hide-empty">
          <ng-content select=".grid-controls-end"/>
        </div>
      </div>
    }
  </div>

  @if (!loading && rowData) {
    <app-list-grid-client-side
      [storageKey]="storageKey"
      [rowData]="rowData"
      [colDefs]="colDefs"
      [gridOptions]="gridOptions"
      [rowSelection]="rowSelection"
      [getRowId]="getRowId"
      [isFullWidthRow]="isFullWidthRow"
      [fullWidthCellRenderer]="fullWidthCellRenderer"
      [rowClassRules]="rowClassRules"
      [getRowHeight]="getRowHeight"
      [statusBar]="statusBar"
      [detailRowAutoHeight]="detailRowAutoHeight"
      [detailCellRenderer]="detailCellRenderer"
      [detailCellRendererParams]="detailCellRendererParams"
      [masterDetail]="masterDetail"
      [quickFilterText]="quickFilterTextValue"
      [defaultExcelExportParams]="defaultExcelExportParams"
      [defaultCsvExportParams]="defaultCsvExportParams"
      [excelStyles]="excelStyles"
      [groupDisplayType]="groupDisplayType"
      [pagination]="pagination"
      [pageSizeList]="pageSizeList"
      [paginationPageSize]="pageSizeService.getPageSize"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [suppressCellFocus]="suppressCellFocus"
      [suppressRowClickSelection]="suppressRowClickSelection"
      [suppressContextMenu]="suppressContextMenu"

      (select)="onSelect($event)"
      (selectAll)="onSelectAll($event)"
      (gridReady)="onGridReady($event)"
    />
  } @else {
    <app-loader/>
  }
</div>
